export default {
    name: 'param-accordion-section',
    components: {},
    props: {
        title: { type: String, required: true },
        description: { type: String, default: '' },
        icon: { type: String, default: 'ic-cog' },
        defaultOpen: { type: Boolean, default: false }
    },
    data() {
        return {
            is_open: this.defaultOpen
        }
    },
    computed: {},
    mounted() {},
    methods: {
        toggle() {
            this.is_open = !this.is_open
        }
    }
}
